import { ChangeEvent } from "react";

import { Button } from "@/components/atoms/buttons/Button";
import { TextField } from "@/components/atoms/inputForms/TextField";

type Props = {
  isApplied: boolean;
  code: string;
  isLoading?: boolean;
  errorMessage?: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onApply: () => void | Promise<void>;
  onCancel: () => void | Promise<void>;
};

export default function CouponCodeField({
  isApplied,
  code,
  isLoading = false,
  errorMessage,
  onChange,
  onApply,
  onCancel,
}: Props) {
  return (
    <div className="border-t border-[#E9EBED] pt-6 mt-6">
      <p className="font-bold text-base text-[#1A1A1A]">クーポンコード</p>
      {isApplied ? (
        <div className="mt-4 flex items-center justify-between gap-4">
          <p className="text-base font-bold text-[#1A1A1A] break-all">{code}</p>
          <Button
            type="button"
            size="md"
            color="primary-outline"
            label="取消"
            onClick={onCancel}
            className="shrink-0"
          />
        </div>
      ) : (
        <>
          <div className="mt-4 flex items-start gap-2">
            <TextField
              name="couponCode"
              value={code}
              placeholder="クーポンコードを入力してください"
              onChange={onChange}
              className="h-[44px] text-base text-[#1A1A1A] !border-[#D9DDE3] flex-1"
            />
            <Button
              type="button"
              size="md"
              color="primary-outline"
              label={isLoading ? "適用中" : "適用"}
              onClick={onApply}
              className="shrink-0"
            />
          </div>
          {errorMessage ? (
            <p className="mt-2 text-sm text-error-msg">{errorMessage}</p>
          ) : null}
        </>
      )}
    </div>
  );
}
